import { executeGetNoResultError } from "../common/apiCaller"
import { GetSessionSettingMstDto } from "../dto/sessionSettingMstDto"

const apiName = 'public'
const apiPath = '/session-setting-mst'

export const executeGetSessionSettingMst = () => {
    return executeGetNoResultError<GetSessionSettingMstDto>(apiName, apiPath)
}  
